<script lang="ts">
	import type { HTMLButtonAttributes } from 'svelte/elements';

	import { m } from '$lib/paraglide/messages.js';

	let { isDrawerOpen = $bindable(), ...rest }: { isDrawerOpen: boolean } & HTMLButtonAttributes =
		$props();
</script>

<button
	onclick={() => (isDrawerOpen = !isDrawerOpen)}
	aria-label={m.menu()}
	{...rest}
	class={['flex cursor-pointer flex-col items-center justify-center gap-0.5', rest.class]}
>
	<span
		class={[
			'block h-0.5 w-6 rounded-xs bg-black transition-all duration-300 ease-out',
			isDrawerOpen ? 'translate-y-1 rotate-45' : '-translate-y-0.5',
		]}
	>
	</span>
	<span
		class={[
			'block h-0.5 w-6 rounded-xs bg-black transition-all duration-300 ease-out',
			isDrawerOpen ? 'opacity-0' : 'opacity-100',
		]}
	>
	</span>
	<span
		class={[
			'block h-0.5 w-6 rounded-xs bg-black transition-all duration-300 ease-out',
			isDrawerOpen ? '-translate-y-1 -rotate-45' : 'translate-y-0.5',
		]}
	>
	</span>
</button>
